import type { Observable } from 'rxjs';
import type { HttpItemsResponse } from '@common/types/http-response.type';
import type { Domain } from '@common/types/domain.type';

import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class DomainsHttpService extends BaseHttpService {
    public getSiteDomains(siteId: number | string): Observable<Domain[]> {
        return this.http.get<HttpItemsResponse<Domain>>(this.formatApiUrl(`sites/${siteId}/domains`)).pipe(
            shareReplay(),
            map((res) => res.items)
        );
    }
}
